<template>
    <button
        type="button"
        class="btn btn-pdv btn-pdv-blue mr-1"
        href="javascript: void(0);"
        :disabled="disabled"
        @click="$emit('onClick')"
    >
        <i :class="icon + ' fas mr-1'"></i>
        {{ title }}
    </button>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
    },
}
</script>
